module.exports = __webpack_public_path__ + "img/menu_logo.66d1471.png";